module.exports = {
    api_key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiY2xpZW50IjoiYXBpIG1vYmlsZSBhcHBzIiwia2V5IjoicmhvZHJXaDAxdkpZS25vTGpGRlpwdWNtc0luQkl6Z3MiLCJpcCI6IiIsImlhdCI6MTQ5OTc2MTg0OH0.DIBAXgFKdSQKIsOl22evLrAjP1vLMGnY8NskWmhHcj0",
    voucher_type : 3,
    idw_url: "https://wap.kmi.mobi/tselOptInLp/REGIDW/KUPON/",
    kjw_url: "https://wap.kmi.mobi/tselOptInLp/REGKJW/KUPON/",
    id4_url: "https://wap.kmi.mobi/tselOptInLp/REGID4/KUPON/",
    spw_url: "https://wap.kmi.mobi/tselOptInLp/REGSPW/KUPON/",
    code_length:6,
    timer: 5 * 60,
    timer_egg: 30,
};
